import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/shared/button';
import ReadinessResults from '@/features/LegacyBenchmarksUI/components/readiness/ReadinessResults';
import { useAuthState } from '@/hooks/useAuthState';
import { ROUTES } from '@/config/routes';
import { storePendingAssessment } from '@/utils/assessmentStorage';

const ReadinessAssessmentDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuthState();

  const handleReviewAssessment = () => {
    navigate(ROUTES.READINESS_ASSESSMENT.WIZARD);
  };

  const handleSave = async (): Promise<void> => {
    if (!user) {
      // Store the current assessment data and redirect to login
      storePendingAssessment({
        answers: {},
        returnTo: ROUTES.READINESS_ASSESSMENT.DASHBOARD
      });
      navigate('/login');
      return Promise.resolve();
    }
    // Handle save for authenticated users
    return Promise.resolve();
  };

  // Temporary mock data - this should be replaced with actual data from your assessment
  const mockScores = {
    1: 4, // Data Inventory
    2: 3, // IT Infrastructure
    3: 4, // Skills & People
    4: 3, // Policy
    5: 5, // Leadership
    6: 4, // Public Buy-in
    7: 3  // Process Maturity
  };

  const mockRecommendations = {
    overallScore: 75,
    timeToValue: "4-6 months",
    quickWins: [
      {
        title: "Document Core Processes",
        description: "Pick your top 3 most common permit types and create detailed process maps for each.",
        effort: "Medium",
        impact: "High"
      }
    ],
    challenges: [
      {
        area: "Process Optimization",
        recommendation: "Implement a systematic process documentation and improvement program."
      }
    ],
    strongAreas: ["Leadership Support", "Data Readiness"],
    weakAreas: ["IT Infrastructure", "Process Maturity"]
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <ReadinessResults
        scores={mockScores}
        recommendations={mockRecommendations}
        onReviewAssessment={handleReviewAssessment}
        onSave={handleSave}
      />
    </div>
  );
};

export default ReadinessAssessmentDashboard;